import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Dentrix Core partner configuration schema
 *
 * Note: Dentrix Core agents do not require configuration fields.
 * The integration is set up at the backend level and does not need
 * customer-provided configuration values (config is null).
 */
export const dentrixCoreSchema: PartnerSchemaInternal = {
  partner: 'dentrix_core' as PartnerEnum,
  displayName: 'Dentrix Core',
  fields: [], // No configuration fields - backend handles setup
}
